import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlinePlus,
  AiOutlinePrinter,
} from "react-icons/ai";

import Modal from "../../../components/Modal";
import Invoice from "../../../components/Invoice";
import NoData from "../../../components/Nodata";

import useStore from "../../../store";

import api from "../../../services/api";

export default ({ customer }) => {
  const [payments, setPayments] = useState();
  const [filters, setFilters] = useState({
    customer_id: customer.id,
    customer_name: customer.name,
  });

  const { user } = useStore();

  useEffect(() => {
    getPayments();
  }, [filters]);

  const getPayments = async (e) => {
    try {
      const { data } = await api.post("payment/search", filters);
      setPayments(data.payments);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (payment) => {
    try {
      if (!window.confirm("Are you sure ?")) return;
      const { data } = await api.remove(`payment&id=${payment.id}`);
      await getPayments();
      toast.success("Successfully deleted !");
    } catch (e) {
      console.log(e);
    }
  };

  if (!payments) return <div className="p-5 text-center">Loading...</div>;

  const totalAmount =
    parseInt(customer.visa_fee || 0) +
    parseInt(customer.embassy_fee || 0) +
    parseInt(customer.appointment_fee || 0) +
    parseInt(customer.hotel_fee || 0) +
    parseInt(customer.ticket_fee || 0) +
    parseInt(customer.insurance_fee || 0) +
    (customer?.services || []).reduce(
      (acc, service) => acc + parseInt(service.fee),
      0
    );
  const paidAmount = payments.reduce(
    (acc, payment) => acc + parseInt(payment.amount),
    0
  );
  const balance = totalAmount - customer.discount - paidAmount;

  return (
    <div>
      <div className="flex items-center space-x-2 justify-end">
        <ViewInvoice
          payments={payments}
          customer={customer}
          totalAmount={totalAmount}
          paidAmount={paidAmount}
        />
        <CreatePayment customer={customer} onChange={getPayments} />
      </div>

      <table className="w-full text-left border-collapse my-5">
        <thead className="text-sm text-gray-400 border-b">
          <tr>
            <th className="py-2 w-1/3">Description</th>
            <th className="py-2">Amount</th>
            <th className="py-2">Method</th>
            <th className="py-2">Created By</th>
            <th className="py-2 text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {payments.map((payment) => (
            <tr
              className="hover:bg-gray-50 border-b"
              // onClick={() => navigate(`/payment/${payment.id}`)}
            >
              <td className="p-2 py-3">
                {payment.type !== "Other" ? payment.type : payment.description}
              </td>
              <td className="p-2 py-3">
                {payment.amount.toLocaleString()} PKR
              </td>
              <td className="p-2 py-3">{payment.method}</td>
              <td className="p-2 py-3">{payment.created_by || "admin"}</td>
              <td>
                <div className="flex justify-end">
                  <UpdatePayment
                    payment={payment}
                    onChange={getPayments}
                    customer={customer}
                  />
                  {user.role === "admin" && (
                    <button
                      title="Delete"
                      onClick={async () => await handleDelete(payment)}
                      className="cursor-pointer bg-red-500 hover:bg-red-700 text-white p-2.5 rounded ml-1 print:hidden"
                    >
                      <AiOutlineDelete />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!payments?.length ? (
        <NoData />
      ) : (
        <div>
          <div className="w-2/5 mt-5">
            <div className="flex justify-between mb-2">
              <span className="text-base font-medium">Amount payable</span>
              <span className="text-base">
                {totalAmount.toLocaleString()} PKR
              </span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="text-base font-medium">Amount paid</span>
              <span className="text-base">
                {paidAmount.toLocaleString()} PKR
              </span>
            </div>
            <hr />
            {customer.discount > 0 && (
              <>
                <div className="flex justify-between mb-2">
                  <span className="text-base font-medium">Discount</span>
                  <span className="text-base">
                    {customer.discount.toLocaleString()} PKR
                  </span>
                </div>
                <hr />
              </>
            )}
            <div className="flex justify-between font-bold text-base mt-4">
              <span>Balance</span>
              <span>{balance.toLocaleString()} PKR</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ViewInvoice = ({ payments, customer, paidAmount, totalAmount }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        title="View Invoice"
        onClick={() => setIsOpen(true)}
        className="cursor-pointer bg-orange-500 hover:bg-orange-700 text-white p-2.5 rounded"
      >
        <AiOutlinePrinter />
      </button>

      <Modal
        title="Invoice"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        className="max-w-3xl"
      >
        <Invoice
          customer={customer}
          payments={payments}
          totalAmount={totalAmount}
          paidAmount={paidAmount}
        />

        <div className="mt-6 flex justify-end print:hidden">
          <button
            onClick={() => window.print()}
            className="cursor-pointer bg-orange-500 hover:bg-orange-700 text-white p-2.5 rounded flex items-center space-x-2"
          >
            <AiOutlinePrinter className="text-lg" /> <span>Print</span>
          </button>
        </div>
      </Modal>
    </>
  );
};

const CreatePayment = ({ customer, onChange }) => {
  const [values, setValues] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  const { user } = useStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      values.updated_by = user.username;
      values.created_by = user.username;
      values.customer_id = customer.id;
      values.customer_name = customer.name;
      await api.post("payment", values);
      await onChange();
      toast.success("Created!");
      setValues({});
      setIsOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="cursor-pointer bg-green-500 hover:bg-green-700 text-white p-2.5 rounded flex items-center space-x-2"
      >
        <AiOutlinePlus />
      </button>

      <Modal
        title="Create new payment"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <form onSubmit={handleSubmit}>
          {/* Section 1: Personal Details */}
          <div className="grid gap-6">
            <InvoiceType
              values={values}
              setValues={setValues}
              customer={customer}
            />

            {values.type === "Other" && (
              <div>
                <label
                  htmlFor="description"
                  className="block text-sm font-medium text-gray-700"
                >
                  Description
                </label>
                <input
                  type="text"
                  id="description"
                  value={values.description}
                  onChange={(e) =>
                    setValues({ ...values, description: e.target.value })
                  }
                  placeholder="Enter description"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
            )}
            <div>
              <label
                htmlFor="amount"
                className="block text-sm font-medium text-gray-700"
              >
                Amount
              </label>
              <input
                type="number"
                id="amount"
                value={values.amount}
                onChange={(e) =>
                  setValues({ ...values, amount: e.target.value })
                }
                placeholder="Enter amount"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                required
              />
            </div>
            <div>
              <label
                htmlFor="method"
                className="block text-sm font-medium text-gray-700"
              >
                Payment Method
              </label>
              <select
                id="method"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                value={values.method}
                onChange={(e) =>
                  setValues({ ...values, method: e.target.value })
                }
                required
              >
                <option value="">Select</option>
                <option value="ONLINE">Online</option>
                <option value="CASH">Cash</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-center space-x-2 mt-5">
            <button
              type="submit"
              className="bg-black text-sm text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
            >
              Submit
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

const UpdatePayment = ({ payment, onChange, customer }) => {
  const [values, setValues] = useState(payment);
  const [isOpen, setIsOpen] = useState(false);

  const { user } = useStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      values.updated_by = user.username;
      const { data } = await api.put("payment", values);
      await onChange();
      toast.success("Updated!");
      setIsOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  if (user.role !== "admin") return null;

  return (
    <>
      <button
        title="Edit"
        onClick={() => setIsOpen(true)}
        className="cursor-pointer bg-blue-500 hover:bg-blue-700 text-white p-2.5 rounded mr-1"
      >
        <AiOutlineEdit />
      </button>

      <Modal
        title="Update payment"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <form onSubmit={handleSubmit}>
          {/* Section 1: Personal Details */}
          <div className="grid gap-6">
            <InvoiceType
              values={values}
              setValues={setValues}
              customer={customer}
            />

            {values.type === "Other" && (
              <div>
                <label
                  htmlFor="description"
                  className="block text-sm font-medium text-gray-700"
                >
                  Description
                </label>
                <input
                  type="text"
                  id="description"
                  value={values.description}
                  onChange={(e) =>
                    setValues({ ...values, description: e.target.value })
                  }
                  placeholder="Enter description"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
            )}
            <div>
              <label
                htmlFor="amount"
                className="block text-sm font-medium text-gray-700"
              >
                Amount
              </label>
              <input
                type="number"
                id="amount"
                value={values.amount}
                onChange={(e) =>
                  setValues({ ...values, amount: e.target.value })
                }
                placeholder="Enter amount"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                required
              />
            </div>
            <div>
              <label
                htmlFor="method"
                className="block text-sm font-medium text-gray-700"
              >
                Payment Method
              </label>
              <select
                id="method"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                value={values.method}
                onChange={(e) =>
                  setValues({ ...values, method: e.target.value })
                }
                required
              >
                <option value="">Select</option>
                <option value="ONLINE">Online</option>
                <option value="CASH">Cash</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-center space-x-2 mt-5">
            <button
              type="submit"
              className="bg-black text-sm text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
            >
              Submit
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

const InvoiceType = ({ values, setValues, customer }) => {
  return (
    <div>
      <label htmlFor="type" className="block text-sm font-medium text-gray-700">
        Payment type
      </label>
      <select
        id="type"
        className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
        value={values.type}
        onChange={(e) =>
          setValues({
            ...values,
            type: e.target.value,
            description: e.target.value,
          })
        }
      >
        <option value="">Select</option>
        <option value="Visa consultancy fee">Visa consultancy fee</option>
        <option value="Embassy fee">Embassy fee</option>
        <option value="Appointment reservation fee">
          Appointment reservation fee
        </option>
        <option value="Hotel booking charges">Hotel booking charges</option>
        <option value="Ticket fee">Ticket fee</option>
        <option value="Insurance fee">Insurance fee</option>
        <option value="Advance payment">Advance payment</option>
        {customer?.services?.map((service) => (
          <option value={service.name}>{service.name}</option>
        ))}
        <option value="Other">Other</option>
      </select>
      {customer?.services?.find((s) => s.name === values.type) && (
        <p className="text-xs mt-2 text-gray-500">
          Service fee:{" "}
          {customer?.services
            ?.find((s) => s.name === values.type)
            .fee.toLocaleString()}{" "}
          PKR
        </p>
      )}
    </div>
  );
};
